import React, { useEffect, useState } from 'react';
import { getPartners } from '../services/wordpress';
import { Partner } from '../types';
import { AlertTriangle } from 'lucide-react';
import './Partners.css';

const Partners: React.FC = () => {
  const [partners, setPartners] = useState<Partner[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
        const data = await getPartners();
        setPartners(data);
        setLoading(false);
    }
    loadData();
  }, []);

  return (
    <section className="Partners_section">
      <div className="container">
        <div className="Partners_header">
          <h2 className="Partners_title">Mitra Strategis</h2>
          <p className="Partners_subtitle">Bekerjasama dengan lembaga nasional dan internasional.</p>
          {partners.length > 0 && partners[0].isFallback && (
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', backgroundColor: 'rgba(255, 255, 255, 0.9)', color: '#d97706', padding: '0.25rem 0.5rem', borderRadius: '0.5rem', fontSize: '0.75rem', fontWeight: 700, marginTop: '0.5rem', border: '1px solid #d97706' }}>
              <AlertTriangle size={14} /> Mode Offline
            </div>
          )}
        </div>
        
        {loading ? (
            <div style={{ display: 'flex', justifyContent: 'center', gap: '2rem', overflow: 'hidden', padding: '2rem 0' }}>
                {[1, 2, 3, 4, 5].map(i => (
                    <div key={i} style={{ width: '150px', height: '80px', backgroundColor: '#e2e8f0', borderRadius: '8px', animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite', flexShrink: 0 }} />
                ))}
                <style>{`@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: .5; } }`}</style>
            </div>
        ) : (
            partners.length === 0 ? (
                <div className="text-center text-slate-400">
                    Belum ada data mitra.
                </div>
            ) : (
                <div className="Partners_sliderContainer">
                    <div className="Partners_track">
                        {/* Render Original List */}
                        {partners.map((partner) => (
                            <PartnerItem key={`original-${partner.id}`} partner={partner} />
                        ))}
                        
                        {/* Render Duplicate List (Untuk efek Infinite Loop) */}
                        {partners.map((partner) => (
                            <PartnerItem key={`duplicate-${partner.id}`} partner={partner} aria-hidden="true" />
                        ))}
                    </div>
                </div>
            )
        )}
      </div>
    </section>
  );
};

// Helper Component untuk item agar kode lebih bersih
const PartnerItem: React.FC<{ partner: Partner; 'aria-hidden'?: boolean | 'true' | 'false' }> = ({ partner, ...rest }) => (
    <a 
        href={partner.website} 
        className="Partners_partnerLink"
        title={partner.name}
        target="_blank"
        rel="noreferrer"
        {...rest}
    >
        <img 
            src={partner.logoUrl} 
            alt={partner.name} 
            className="Partners_logo"
            loading="lazy"
            width="150"
            height="80"
            onError={(e) => {
                (e.target as HTMLImageElement).src = `https://placehold.co/150x80?text=${partner.name}`;
            }}
        />
    </a>
);

export default Partners;

